import { setIsNowbtnClicked } from '@store/commonSlice';
import { useAppDispatch } from '@store/index';
import { formatTimeFromUTC } from '@utils/common';
import { useTranslation } from 'react-i18next';

const NowTime = ({ time, refreshFn }: { time: string | undefined; refreshFn: () => void }) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const onChange = () => {
        refreshFn();
        dispatch(setIsNowbtnClicked(true));
    };

    return (
        <div className="text-end text-base text-black068 leading-[21px] pt-[18px] pb-[10px] px-[16px] lg:px-0 lg:py-0">
            <span className="inline-block mr-[4px] align-middle">{t('I007')}</span>
            <span className="align-middle">{time ? formatTimeFromUTC(time) : ''}</span>
            <button
                onClick={onChange}
                className="w-[14px] h-[14px] bg-refreshlight ml-[8px] align-middle lg:bg-contain lg:w-[13px] lg:h-[13px]"
            ></button>
        </div>
    );
};
export default NowTime;
